import { createSlice } from "@reduxjs/toolkit";
import { createReport } from "./reportActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  lastReport: null,
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    clearReportError: (state) => {
      state.error = null;
    },
    resetReportState: (state) => {
      state.success = false;
      state.lastReport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReport.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createReport.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.lastReport = action.payload;
      })
      .addCase(createReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { clearReportError, resetReportState } = reportSlice.actions;
export default reportSlice.reducer;
